export type ThemeColors = {
    primary: string;
    primaryLight: string;
    primaryDark: string;
    secondary: string;
    secondaryLight: string;
    secondaryDark: string;
    background: string;
    surface: string;
    border: string;
    error: string;
    warning: string;
    success: string;
    info: string;
    textPrimary: string;
    textSecondary: string;
};

export type ThemeColorKey = keyof ThemeColors;

export const DEFAULT_THEME_COLORS: ThemeColors = {
    primary: '#F7941F',
    primaryLight: '#FDB848',
    primaryDark: '#D97A00',
    secondary: '#FF4747',
    secondaryLight: '#FF7676',
    secondaryDark: '#E02020',
    background: '#F5F5F5',
    surface: '#ffffff',
    border: '#E8E8E8',
    error: '#e5484d',
    warning: '#f5a623',
    success: '#30a46c',
    info: '#0091ff',
    textPrimary: '#11181c',
    textSecondary: '#687076'
};

export const THEME_COLOR_GROUPS: { titleKey: string; keys: ThemeColorKey[] }[] = [
    { titleKey: 'clients.theme.groups.main', keys: ['primary', 'primaryLight', 'primaryDark', 'secondary', 'secondaryLight', 'secondaryDark'] },
    { titleKey: 'clients.theme.groups.surfaces', keys: ['background', 'surface', 'border'] },
    { titleKey: 'clients.theme.groups.semantic', keys: ['error', 'warning', 'success', 'info'] },
    { titleKey: 'clients.theme.groups.text', keys: ['textPrimary', 'textSecondary'] }
];
